import { render, staticRenderFns } from "./reminderView.vue?vue&type=template&id=bdf29f4c&"
import script from "./reminderView.vue?vue&type=script&lang=js&"
export * from "./reminderView.vue?vue&type=script&lang=js&"
import style0 from "./reminderView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports